import { defaultSortOptionValue } from 'entities/kyrgyzstan/model/search/sort'

interface GetFilterActiveStateProps {
  sort: string
  realty_type_ids?: number[]
}

export const getFilterActiveState = ({
  sort,
  realty_type_ids,
}: GetFilterActiveStateProps) => {
  return {
    sort: sort !== defaultSortOptionValue,
    filters: realty_type_ids !== undefined && realty_type_ids.length > 0,
  }
}
